import { UseSuspenseQueryOptions } from '@tanstack/react-query';
import {
    ReservationExtent,
    ReservationFilterParameters,
    ReservationResult,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';

const defaultExtent: ReservationExtent = {
    accounts: false,
    reservationGroups: false,
    availabilityBlocks: false,
    companionships: false,
    orderItems: false,
    products: false,
    businessSegments: false,
    generalNotes: false,
    channelManagerNotes: false,
    vouchers: false,
    partnerCompanies: false,
    rates: false,
    specialRequestNotes: false,
    travelAgencies: false,
    origin: false,
    bookingEngines: false,
    purchaseOrderNumbers: false,
};

type useReservationsSuspenseQueryParams = Omit<ReservationFilterParameters, 'extent'> & {
    extent: Partial<ReservationFilterParameters['extent']>;
};

type Options<T> = Pick<UseSuspenseQueryOptions<ReservationResult, Error, T>, 'select'>;

export const useReservationsSuspenseQuery = <T>(params: useReservationsSuspenseQueryParams, options?: Options<T>) =>
    useRepositorySuspenseQuery(
        'reservations',
        'getAll',
        {
            ...params,
            extent: {
                ...defaultExtent,
                ...params.extent,
            },
        },
        options
    );
